import React, { useState } from "react";
import Header from "./Header";
import { subscribeToWebpush } from "../WebpushFunc";

import { _common } from "../common";
const common = _common;


export default function RegisterWebpush() {
  const [error, setError] = useState<string | undefined>(undefined);


  return (
    <div id="top" style={{ height: "100vh", width: "100vw", overflow: "hidden" }}>
      <div
        id="innerMain"
        style={{
          height: "100%",
          width: "100%",
          maxWidth: "400px",
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Header />
        <div style={{
          flexGrow: "1",
          textAlign: "center",
          fontSize: "1em",
          padding: "50px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center"
        }}>

          <p> Du hast noch nicht beim Infoservice des TCGW Buchungssystems aktiviert.
          </p>
          <p>
            Aktiviere ihn jetzt,
            <br />
            um zukünfig Hinweise über neue Buchungen und Erinnerungen über anstehende Matches auf Deinem Telefon zu erhalten.
          </p>


          <br />

          <button
            style={{ float: "right", marginTop: "10px", marginRight: "10px" }}
            className="btn btn-primary"
            type="button"
            onClick={async () => {
              const user = JSON.parse(common.getUserFromLocalStorage());
              if (await subscribeToWebpush(user.memberId)) {
                user.webpushRegistered = true;
                localStorage?.setItem("user", JSON.stringify(user));

                window.location.href = "/booking?force";
              }
            }}
          >
            Jetzt aktivieren
          </button>

          <br />
          <br />

          <a
            style={{ float: "right", marginTop: "10px", marginRight: "10px" }}
            type="button"
            href="/booking?force"
          >
            Weiter ohne TCGW Infoservice
          </a>



          {error && (
            <div className="error" style={{ backgroundColor: "#ff8888", padding: "1em" }}>
              <div id="msg1" style={{ textAlign: "center", fontSize: "1em" }}>
                {error}
              </div>
            </div>
          )}
        </div>
      </div>
    </div >
  );
}
